import type { MonetizationView } from '@mezha/api'
import { http } from '../../api/client'
import { LocationWindow } from '../LocationWindow'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { logout, useMeQuery } from '../../api/endpoints/auth'
import { useHeroQuery } from '../../api/endpoints/hero'
import { useAppDispatch, useAppSelector } from '../../app/store'
import { ui } from '../../app/uiSlice'
import { PLATFORM_NAME } from '../../platform/detect'
import { useShellMode } from '../../shell/ShellContext'
import { Failure, Loading } from '../../ui/State'
import { PlankButton, Sheet } from '../../ui'

const PROVIDER_RU: Record<string, string> = { password: 'логин и пароль', vk: 'VK', yandex: 'Яндекс Игры' }

/** `/play/settings`: less motion, the account and signing out. */
export function Settings() {
  useShellMode('window')
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const lessMotion = useAppSelector(s => s.ui.lessMotion)
  const platform = useAppSelector(s => s.session.platform)
  const me = useMeQuery()
  const hero = useHeroQuery()
  const [confirm, setConfirm] = useState(false)
  const [leaving, setLeaving] = useState(false)
  const [testPayment, setTestPayment] = useState(false)
  useEffect(() => { if (platform === 'vk') void http.get<MonetizationView>('/api/v1/monetization').then(v => setTestPayment(v.test_mode && v.test_allowed)).catch(() => setTestPayment(false)) }, [platform])

  const signOut = async () => {
    setLeaving(true)
    await logout()
    navigate(platform === 'web' ? '/login' : '/', { replace: true })
  }

  return (
    <LocationWindow title="Настройки" emblem="nav.settings" idBase="settings" bodyClassName="shell-panel">
      <div className="shell-panel__list">
        <label className="shell-panel__setting slab">
          <input type="checkbox" checked={lessMotion} onChange={e => dispatch(ui.actions.lessMotion(e.target.checked))} />
          Уменьшить анимацию
        </label>
      </div>
      <section className="shell-panel__sheet parch" aria-labelledby="account-title">
        <h3 id="account-title">Учётная запись</h3>
        {me.isLoading && <Loading />}
        {me.isError && !me.data && <Failure error={me.error} retry={() => void me.refetch()} what="Учётная запись" />}
        {me.data && (
          <dl className="settings__facts">
            <dt>Герой</dt><dd>{hero.data ? `${hero.data.name}, ур. ${hero.data.level}` : '—'}</dd>
            <dt>Вход</dt><dd>{me.data.providers.map(p => PROVIDER_RU[p] ?? p).join(', ')}</dd>
            <dt>Площадка</dt><dd>{PLATFORM_NAME[platform]}</dd>
            <dt>Номер</dt><dd>{me.data.account_id}</dd>
            {me.data.muted && <><dt>Чат</dt><dd>запрет писать{me.data.muted_until ? ` до ${new Date(me.data.muted_until).toLocaleString('ru-RU')}` : ''}</dd></>}
          </dl>
        )}
      </section>
      <>{testPayment && <PlankButton onClick={() => navigate('/play/vk-payment-test')}>Тестовый платёж VK</PlankButton>}</>
      <PlankButton className="shell-panel__action" onClick={() => setConfirm(true)}>Выйти</PlankButton>
      <Sheet open={confirm} title="Выйти из игры?" emblem="loc.exit" onClose={() => setConfirm(false)}>
        <p className="note">{platform === 'web' ? 'Для входа понадобятся логин и пароль.' : `Войти снова можно будет через ${PLATFORM_NAME[platform]}.`}</p>
        <div className="actions">
          <PlankButton gold onClick={() => void signOut()} disabled={leaving}>{leaving ? 'Выходим…' : 'Выйти'}</PlankButton>
          <PlankButton onClick={() => setConfirm(false)}>Остаться</PlankButton>
        </div>
      </Sheet>
    </LocationWindow>
  )
}
